// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Avatar, Grid2, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { IInventoryDetail } from '~/utils/interface/inventory';
// Styles, images, icons
import styles from './PhotoProductDetail.module.scss';

type Props = {
  detailProduct?: IInventoryDetail;
};

const cx = classNames.bind(styles);

const PhotoProductDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailProduct } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/inventory', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='photoProductDetailComponent' gap={6} className={cx('container')}>
      <Typography className={cx('textHeader')}>{t('inventory_detail_title_product_photos')}</Typography>

      <Grid2 container spacing={'18px'}>
        {detailProduct && detailProduct.inventoryImages.length > 0 ? (
          detailProduct.inventoryImages.map((item, index) => {
            return (
              <Grid2 size={6} key={index} className={cx('itemImage')}>
                <Avatar
                  src={item?.url}
                  alt={t('common_alt_img', { ns: 'common/base' })}
                  variant='rounded'
                  className={cx('image')}
                />
              </Grid2>
            );
          })
        ) : (
          <Typography align='center' className={cx('noData')}>
            {t('common_no_data_available', { ns: 'common/base' })}
          </Typography>
        )}
      </Grid2>
    </Stack>
  );
};

export default PhotoProductDetail;
